import React from "react";
import { IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function StyledPatchFavoriteButton({ children, onClick }) {
  const theme = useTheme();

  return (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        top: 0,
        right: 0,
        ".MuiSvgIcon-root": {
          width: "0.75em",
          height: "0.75em",
        },
        [theme.breakpoints.down("laptop")]: {
          padding: "4px",
        },
      }}
    >
      {children}
    </IconButton>
  );
}

export default React.memo(StyledPatchFavoriteButton);
